var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as TypeGraphQL from "type-graphql";
import * as GraphQLScalars from "graphql-scalars";
import { Prisma } from "@prisma/client";
import { DecimalJSScalar } from "../scalars.mjs";
let PortfolioGreeksHistory = class PortfolioGreeksHistory {
    /**
     * Unique identifier for the portfolio Greeks history record
     */
    id;
    /**
     * Account identifier for multi-account support
     */
    accountId;
    /**
     * Timestamp of the Greeks snapshot
     */
    timestamp;
    /**
     * Optional reference to specific contract
     */
    contractId;
    /**
     * Option contract symbol (if contract-specific)
     */
    symbol;
    /**
     * Underlying asset symbol
     */
    underlying;
    /**
     * Individual Greeks for contract or position
     */
    delta;
    gamma;
    theta;
    vega;
    rho;
    /**
     * Total portfolio delta exposure
     */
    totalDelta;
    /**
     * Total portfolio gamma exposure
     */
    totalGamma;
    /**
     * Total portfolio theta exposure
     */
    totalTheta;
    /**
     * Total portfolio vega exposure
     */
    totalVega;
    /**
     * Total portfolio rho exposure
     */
    totalRho;
    /**
     * Number of positions in portfolio
     */
    positionCount;
    /**
     * List of underlying symbols in portfolio
     */
    underlyingSymbols;
    /**
     * List of expiration dates in portfolio
     */
    expirationDates;
    /**
     * Whether recorded during market hours
     */
    marketHours;
    /**
     * VIX level at timestamp
     */
    vix;
    /**
     * SPY price at timestamp
     */
    spyPrice;
    /**
     * Data source identifier
     */
    source;
    /**
     * Record creation timestamp
     */
    createdAt;
};
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: false,
        description: "Unique identifier for the portfolio Greeks history record"
    }),
    __metadata("design:type", String)
], PortfolioGreeksHistory.prototype, "id", void 0);
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: false,
        description: "Account identifier for multi-account support"
    }),
    __metadata("design:type", String)
], PortfolioGreeksHistory.prototype, "accountId", void 0);
__decorate([
    TypeGraphQL.Field(_type => Date, {
        nullable: false,
        description: "Timestamp of the Greeks snapshot"
    }),
    __metadata("design:type", Date)
], PortfolioGreeksHistory.prototype, "timestamp", void 0);
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: true,
        description: "Optional reference to specific contract"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "contractId", void 0);
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: true,
        description: "Option contract symbol (if contract-specific)"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "symbol", void 0);
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: false,
        description: "Underlying asset symbol"
    }),
    __metadata("design:type", String)
], PortfolioGreeksHistory.prototype, "underlying", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: false,
        description: "Individual Greeks for contract or position"
    }),
    __metadata("design:type", Prisma.Decimal)
], PortfolioGreeksHistory.prototype, "delta", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: false
    }),
    __metadata("design:type", Prisma.Decimal)
], PortfolioGreeksHistory.prototype, "gamma", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: false
    }),
    __metadata("design:type", Prisma.Decimal)
], PortfolioGreeksHistory.prototype, "theta", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: false
    }),
    __metadata("design:type", Prisma.Decimal)
], PortfolioGreeksHistory.prototype, "vega", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: false
    }),
    __metadata("design:type", Prisma.Decimal)
], PortfolioGreeksHistory.prototype, "rho", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "Total portfolio delta exposure"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "totalDelta", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "Total portfolio gamma exposure"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "totalGamma", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "Total portfolio theta exposure"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "totalTheta", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "Total portfolio vega exposure"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "totalVega", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "Total portfolio rho exposure"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "totalRho", void 0);
__decorate([
    TypeGraphQL.Field(_type => TypeGraphQL.Int, {
        nullable: true,
        description: "Number of positions in portfolio"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "positionCount", void 0);
__decorate([
    TypeGraphQL.Field(_type => GraphQLScalars.JSONResolver, {
        nullable: true,
        description: "List of underlying symbols in portfolio"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "underlyingSymbols", void 0);
__decorate([
    TypeGraphQL.Field(_type => GraphQLScalars.JSONResolver, {
        nullable: true,
        description: "List of expiration dates in portfolio"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "expirationDates", void 0);
__decorate([
    TypeGraphQL.Field(_type => Boolean, {
        nullable: true,
        description: "Whether recorded during market hours"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "marketHours", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "VIX level at timestamp"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "vix", void 0);
__decorate([
    TypeGraphQL.Field(_type => DecimalJSScalar, {
        nullable: true,
        description: "SPY price at timestamp"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "spyPrice", void 0);
__decorate([
    TypeGraphQL.Field(_type => String, {
        nullable: true,
        description: "Data source identifier"
    }),
    __metadata("design:type", Object)
], PortfolioGreeksHistory.prototype, "source", void 0);
__decorate([
    TypeGraphQL.Field(_type => Date, {
        nullable: false,
        description: "Record creation timestamp"
    }),
    __metadata("design:type", Date)
], PortfolioGreeksHistory.prototype, "createdAt", void 0);
PortfolioGreeksHistory = __decorate([
    TypeGraphQL.ObjectType("PortfolioGreeksHistory", {})
], PortfolioGreeksHistory);
export { PortfolioGreeksHistory };
//# sourceMappingURL=PortfolioGreeksHistory.js.map